import * as yup from 'yup';
import { MovementColor } from '../../../enums';

export const MovementStatusSchema = yup.object({
  description: yup.string().notRequired().nullable(),
});

export interface IMovementStatus {
  id?: string;
  createdAt?: Date;
  createdBy?: {
    name: {
      firstFull: string;
      last: string;
    };
  };
  residentId?: string;
  description?: string;
  contracturePresent: boolean;
  bendAndStraightenHead?: MovementColor[];
  turnHead?: MovementColor[];
  armsSidewardsFromTheBottomUpToLeft?: MovementColor[];
  armsSidewardsFromTheBottomUpToRight?: MovementColor[];
  armsForwardFromTheBottomUpToLeft?: MovementColor[];
  armsForwardFromTheBottomUpToRight?: MovementColor[];
  bendAndStraightenElbowToLeft?: MovementColor[];
  bendAndStraightenElbowToRight?: MovementColor[];
  bendAndStraightenHandToLeft?: MovementColor[];
  bendAndStraightenHandToRight?: MovementColor[];
  openAndCloseHandToLeft?: MovementColor[];
  openAndCloseHandToRight?: MovementColor[];
  bendAndStraightenHipJointToLeft?: MovementColor[];
  bendAndStraightenHipJointToRight?: MovementColor[];
  raiseAndLowerFootToLeft?: MovementColor[];
  raiseAndLowerFootToRight?: MovementColor[];
  bendAndStraightenLowerLegToLeft?: MovementColor[];
  bendAndStraightenLowerLegToRight?: MovementColor[];
}
